module.exports = __webpack_public_path__ + "img/lianxiren.5a114f01.svg";